import SensorStyle from "./SensorStyle.module.css"
import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import Map from "./sensorMap/Map.js";
import { responseMsg } from "../common/ResponseMsg";
import moment from "moment";
import Flex from "../../shared/components/Flex";
import IcoDanger from "../../assets/img/IcoDanger";
import Text from "../../shared/components/Text";
import useDevice from "../../shared/hooks/useDevice";
import InnerFlex from "../../features/common/components/InnerFlex";
import LabelInput from "../../shared/components/LabelInput";
import LabelSelect from "../../shared/components/LabelSelect";
import ModalButton from "../../shared/components/ModalButton";
import { useAlert } from "../../shared/components/AlertProvider";

function ContentModal(props) {
    const { mode, data, close } = props;
    const [ regionDepth1, setRegionDepth1 ] = useState([]);  
    const [ regionDepth2, setRegionDepth2 ] = useState([]);
    const [ selectedRegionDepth1, setSelectedRegionDepth1 ] = useState();
    const [ selectedRegionDepth2, setSelectedRegionDepth2 ] = useState();
    const [ useAutoSpray, setUseAutoSpray ] = useState("N");
    const {
        handleSubmit,
        register,
        formState: { errors },
        reset,
        getValues,
        setValue,
    } = useForm({defaultValues: {...data, ...(data?.installDt && {installDt:moment(data.installDt).format('YYYY-MM-DDTHH:mm:ss')})}});
    const sprayComboList = [
        {"sprayKey" : "Y", "sprayName": "사용"},
        {"sprayKey": "N", "sprayName": "미사용"}
    ];
    const device = useDevice();
    const isMobile = device !== "desktop";
    const showAlert = useAlert();
  
    useEffect(() => {
        const categorizedData = props.regions?.reduce((result, obj) => {
        if(obj.depth === 2){
            result.depth1.push(obj);
        } else if(obj.depth === 3) {
            result.depth2.push(obj);
        }

        return result;
        } , {depth1 : [], depth2: []})

        setSelectedRegionDepth1(mode === 'update' ? data.region.parent :categorizedData.depth1[0]?.id);
        setSelectedRegionDepth2(mode === 'update' ? data.region.id : categorizedData.depth2[0]?.id)
        setRegionDepth1(categorizedData.depth1);
        setRegionDepth2(categorizedData.depth2);

        setUseAutoSpray(mode === 'update' ? data.useAutoSpray : "N");
        setValue("useAutoSpray", mode === "update" ? data.useAutoSpray : "N", { shouldDirty: true });
    }, [])

    const [readOnly, setReadOnly] = useState(false);

    // 삭제
    const btnDelete = (e) => {
        fetch(`/api/system/sensors/${data.imei}`, {
            method: "DELETE",
        })
        .then((res) => res.json())
        .then((json) => {
            if (json.code === responseMsg.SUCCESS.code) {
                showAlert({ title: "알림", text: "삭제완료" })
                close(false);
                props.rendering();
                
            }  else if (json.code === responseMsg.FAIL.code) {
                showAlert({title: "오류", text: "통신이 지연되고 있습니다..", type: "error"})
            }
        })
        .catch((error) => {
            showAlert({title: "오류", text: "정상적으로 처리되지 않았습니다.", type: "error"})
        });

    }

  // 저장
  const onSubmit = (formData) => {
    if(formData.manageCd.trim() === ""){
        showAlert({
            title: "주의",
            text: "관리번호를 입력해주세요.",
            type: "warning"
        });
        return;
    } else if(formData.imei.trim() === ""){
        showAlert({
            title: "주의",
            text: "IMEI 값은 필수 입력입니다.\n(수정이 불가능하니 주의해주세요)",
            type: "warning"
        });
        return;
    }
    if (mode === 'insert') {
        fetch("/api/system/sensors", {
            method: "POST",
            headers: {
            "Content-Type": "application/json",
            },
            body: JSON.stringify({...formData, region:selectedRegionDepth2}),
        })
        .then((res) => res.json())
        .then((json) => {
            if (json.code === responseMsg.SUCCESS.code) {
                showAlert({ title: "알림", text: "등록완료" })
                close(false);
                props.rendering();
                
            }  else if (json.code === responseMsg.FAIL.code) {
                showAlert({title: "오류", text: "통신이 지연되고 있습니다..", type: "error"})
            }
        })
        .catch((error) => {
            showAlert({title: "오류", text: "정상적으로 처리되지 않았습니다.", type: "error"})
        });

        } else if (mode === 'update'){
        fetch("/api/system/sensors", {
            method: "PATCH",
            headers: {
            "Content-Type": "application/json",
            },
            body: JSON.stringify({...formData, region:selectedRegionDepth2}),
        })
        .then((res) => res.json())
        .then((json) => {
            if (json.code === responseMsg.SUCCESS.code) {
                showAlert({ title: "알림", text: "등록완료" })
                close(false);
                props.rendering();
                
            }  else if (json.code === responseMsg.FAIL.code) {
                showAlert({title: "오류", text: "통신이 지연되고 있습니다..", type: "error"})
            }
        })
        .catch((error) => {
            showAlert({title: "오류", text: "정상적으로 처리되지 않았습니다.", type: "error"})
        });
    }
  }

  // 좌표값 추출
  const getCoordinate = (value) => {
    setValue('x', value[0]);
    setValue('y', value[1]);
  }

    const regionDepth1Option = regionDepth1?.map((item) => ({
            text: item.name,
            value: item.id,
            default: item.id === selectedRegionDepth1
        })) ?? [];
        
    const regionDepth2Option = regionDepth2?.filter(ele => ele.parent == selectedRegionDepth1)?.map((item) => ({
            text: item.name,
            value: item.id,
            default: item.id === selectedRegionDepth2
        })) ?? [];
    
    const sprayComboOption = sprayComboList.map((item) => ({
            text: item.sprayName,
            value: item.sprayKey,
            default: item.sprayKey === useAutoSpray
        })) ?? [];


    return (
        <>
            <Flex flexDirection={isMobile ? "column" : "row"} gap={25}>
                <div className={SensorStyle.modalLeft}>
                    <Map viewData={data ? data : null} clickEvent={getCoordinate} />
                    <Flex gap={8} paddingY={15} justifyContent="center" style={{backgroundColor: "#F7F9FA", color: "#FF3B3B", marginTop: "8px", borderRadius: "12px", textAlign: "center"}}>
                        <IcoDanger/> <Text size={"sm"} weight={"md"}>지도에서 위치를 선택해 주세요.</Text>
                    </Flex>
                </div>
                <form className={`input_wrap ${SensorStyle.form}`}>
                    <InnerFlex>
                        <LabelInput required id="manageCd" label={"관리번호"} placeholder="관리번호를 입력해 주세요" maxLength={20} fullWidth {...register("manageCd")}/>
                        <LabelInput required id="imei" label={"IMEI"} placeholder="IMEI를 입력해 주세요" maxLength={50} readOnly={mode === "update"} fullWidth {...register("imei")}/>
                    </InnerFlex>

                    <InnerFlex>
                        <LabelSelect id="sido" label={"지역"} 
                            value={selectedRegionDepth1}
                            disabled={regionDepth1.length === 1} 
                            options={regionDepth1Option}
                            name={"sido"}
                            onChange={(e) => {
                                setSelectedRegionDepth1(e);
                                setSelectedRegionDepth2(regionDepth2?.filter(ele => ele.parent == e)[0].id);
                            }}
                            fullWidth 
                        />
                        <LabelSelect id="region" label={"세부지역"} 
                            value={selectedRegionDepth2}
                            name={"region"}
                            disabled={regionDepth2.length === 1} 
                            options={regionDepth2Option}
                            onChange={(e) => setSelectedRegionDepth2(e)}
                            fullWidth 
                        />
                    </InnerFlex>

                    <InnerFlex>
                        <LabelInput id="x" label={"위도"} placeholder="위도를 입력해 주세요" fullWidth {...register("x")}/>
                        <LabelInput id="y" label={"경도"} placeholder="경도를 입력해 주세요" fullWidth {...register("y")}/>
                    </InnerFlex>

                    <InnerFlex>
                        <LabelInput id="address" label={"주소"} fullWidth {...register("address")}/>
                    </InnerFlex>
                    
                    <InnerFlex>
                        <LabelInput id="department" label={"부서"} fullWidth {...register("department")}/>
                        <LabelInput id="comment" label={"비고"} fullWidth {...register("comment")}/>
                    </InnerFlex>

                    <InnerFlex>
                        <LabelInput id="installDt" label={"설치일"} type="datetime-local" defaultValue={moment().format("YYYY-MM-DD HH:mm:ss")} fullWidth {...register("installDt")}/>
                    </InnerFlex>
                    
                    <InnerFlex>
                        <LabelSelect id="useAutoSpray" label={"자동염수분사"} 
                            value={useAutoSpray}
                            options={sprayComboOption}
                            name={"useAutoSpray"}
                            onChange={(e) => {setUseAutoSpray(e); setValue("useAutoSpray", e, { shouldDirty: true });}}
                            fullWidth 
                        />
                        <LabelInput id="deviceId" label={"염수분사 장치ID"} fullWidth {...register("deviceId")}/>
                    </InnerFlex>
                </form>
            </Flex>
            <Flex flexDirection={isMobile ? "column" : "row"} fullWidth justifyContent="end" gap={10}>
                <ModalButton type={mode} onClick={handleSubmit(onSubmit)} />
                {mode === "update" ? (
                    <ModalButton type="delete" onClick={btnDelete} />
                    ) : null
                }
                <ModalButton type="cancel" onClick={close} />
            </Flex>
        </>

    );
}

export default ContentModal;
